var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignalNeverSeen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_408_6)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.9999 17.0881C80.5792 17.0881 98.9119 35.4208 98.9119 58.0001C98.9119 80.5794 80.5792 98.912 57.9999 98.912C35.4206 98.912 17.088 80.5794 17.088 58.0001C17.088 35.4208 35.4206 17.0881 57.9999 17.0881Z",
    fill: "url(#paint0_linear_408_6)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.19
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58 5.22119C87.1287 5.22119 110.779 28.8714 110.779 58.0001C110.779 87.1288 87.1287 110.779 58 110.779C28.8713 110.779 5.22107 87.1288 5.22107 58.0001C5.22107 28.8714 28.8713 5.22119 58 5.22119Z",
    fill: "url(#paint1_linear_408_6)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.19
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58 0C90.0102 0 116 25.9898 116 58C116 90.0102 90.0102 116 58 116C25.9898 116 0 90.0102 0 58C0 25.9898 25.9898 0 58 0Z",
    fill: "url(#paint2_linear_408_6)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 0C90.0102 0 116 25.9898 116 58C116 90.0102 90.0102 116 58 116C25.9898 116 0 90.0102 0 58C0 25.9898 25.9898 0 58 0Z",
    fill: "url(#paint3_linear_408_6)",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.9999 10.907C83.9907 10.907 105.093 32.0094 105.093 58.0002C105.093 83.9909 83.9907 105.093 57.9999 105.093C32.0092 105.093 10.9067 83.9909 10.9067 58.0002C10.9067 32.0094 32.0092 10.907 57.9999 10.907Z",
    fill: "url(#paint4_linear_408_6)",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_408_6",
    x1: 57.9999,
    y1: 16.2358,
    x2: 57.9999,
    y2: 98.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C1C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_408_6",
    x1: 58,
    y1: 4.12163,
    x2: 58,
    y2: 110.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C1C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_408_6",
    x1: 58,
    y1: -1.20833,
    x2: 58,
    y2: 116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBBBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_408_6",
    x1: 58,
    y1: -1.20833,
    x2: 58,
    y2: 116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBBBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_408_6",
    x1: 57.9999,
    y1: 9.92585,
    x2: 57.9999,
    y2: 105.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4B4B4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_408_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 116,
    height: 116,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalNeverSeen);
export default __webpack_public_path__ + "static/media/signal-never-seen.fa520c76b9b36a0ba0d2a15de993665b.svg";
export { ForwardRef as ReactComponent };